/**
 * Copyright 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Text, theme } from "@nordcloud/gnui";
import { FilterWrapper, InputLoader, getSelectedMode } from "~/components";
import { isEmpty } from "~/tools";
import { isArrayFilterSelected } from "~/utils";
import { isExcluded } from "../helpers";
import { useDataOptions, useFilters } from "../hooks";
import { AppEnvAccordion } from "./AppEnvAccordion";
import { SidebarFilterProps } from "./types";
import { UnallocatedEstateFilter } from "./UnallocatedEstateFilter";

export function CostAllocationFilters({
  filters,
  updateFilters,
}: SidebarFilterProps) {
  const {
    clearApplicationFilter,
    isUnallocatedFilterSelected,
    clearUnallocatedFilters,
  } = useFilters({
    filters,
    updateFilters,
  });

  const { loadingCloudWastePoliciesCategorised } = useDataOptions(filters);

  return (
    <>
      <Text weight="medium" marginTop={theme.spacing.spacing04}>
        Cost Allocation
      </Text>
      <FilterWrapper
        name="Applications and Environments"
        selectedOptions={filters.environment}
        isSelected={
          isArrayFilterSelected(filters.environment) ||
          isArrayFilterSelected(filters.application)
        }
        onClear={clearApplicationFilter}
      >
        <AppEnvAccordion
          selectedEnvironments={filters.environment ?? []}
          selectedApplications={filters.application ?? []}
          isCleared={isEmpty(filters.environment ?? [])}
          headerProps={{
            allowModeChange: true,
            defaultMode: getSelectedMode(filters.environmentExclude),
            onModeChange: (mode) =>
              updateFilters({ environmentExclude: isExcluded(mode) }),
          }}
          onMultiSelect={updateFilters}
        />
      </FilterWrapper>
      <FilterWrapper
        name="Unallocated Estate Records"
        isSelected={isUnallocatedFilterSelected}
        onClear={clearUnallocatedFilters}
      >
        <InputLoader loading={loadingCloudWastePoliciesCategorised}>
          <UnallocatedEstateFilter
            filters={filters}
            updateFilters={updateFilters}
            isExcludeSelected={filters.unassignedExclude}
            onModeChage={(mode) =>
              updateFilters({ unassignedExclude: isExcluded(mode) })
            }
          />
        </InputLoader>
      </FilterWrapper>
    </>
  );
}
